import React from 'react';
import { ShieldCheckIcon, StethoscopeIcon } from 'lucide-react';
export function VetConnect() {
  return <section aria-labelledby="vet-title" className="mt-10 flex flex-wrap items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50 p-6" data-id="element-240" data-mp="nhcw581dys8d">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-ville-indigo" aria-hidden="true" data-id="element-241" data-mp="wag26v9pc2sz">
        <StethoscopeIcon className="h-6 w-6" data-id="element-242" data-mp="11ac7qyy1s2an" />
      </span>
      <div className="min-w-0 flex-1" data-id="element-243" data-mp="11bx2opo9xn91">
        <h2 id="vet-title" className="text-[15px] font-extrabold text-ville-navy" data-id="element-244" data-mp="167ujsy7d2xmv">
          Veterinary services — Vet&amp;Co
        </h2>
        <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-245" data-mp="1b8i83c47h0de">
          Connect your pet to your clinic with your consent. You choose which pet and which information is shared.
        </p>
        <p className="mt-2 flex items-center gap-1.5 text-xs text-slate-500" data-id="element-246" data-mp="3d0ob6dr2gpfz">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-247" data-mp="3h1qaeukzh1hy" />
          No health information is shared automatically.
        </p>
      </div>
      <button type="button" className="rounded-full border border-ville-navy px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-248" data-mp="3m2s90fvkf5c7">
        Connect Vet&amp;Co
      </button>
    </section>;
}